import "./Footer.scss";

// code imports
import React from 'react';
import { Link } from 'react-router-dom';
import { SOCIAL_LINKS as SOCIALS } from '../socialLinks';

const LOGO = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/hitwicket-logo.png";
const APP_STORE_BADGE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/app_store_badge.png";
const PLAY_STORE_BADGE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/play_store_badge_v1.png";
const APP_STORE_LINK = "https://apps.apple.com/in/app/hitwicket-cricket-game/id1498437026?itsct=apps_box_badge&itscg=30200&utm_source=hw-website&utm_campaign=website-2023&utm_content=home-footer";
const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=cricketgames.hitwicket.strategy&hl=en_IN&gl=US&utm_source=hw-website&utm_campaign=website-2023&utm_content=home-footer";
const CAREERS_LINK = "https://pear-teal-79a.notion.site/Work-at-Hitwicket-105e348bbbca80c7ad3be17555990d09?pvs=73";


function Footer({ page }) {
  // legal links (the FAQs link only exists on the HCL pages, as before)
  const legalLinks = [
    { to: "terms", text: "Terms" },
    { to: "privacy-policy", text: "Privacy Policy" },
    ...(page === "hcl" ? [{ to: "hcl/faqs", text: "FAQs" }] : []),
    { to: "community-guidelines", text: "Community Guidelines" },
    { to: "refund-policy", text: "Refund Policy" },
  ];

  // clicking the link of the page you're already on just scrolls to the top
  const handleLegalClick = (to) => (e) => {
    if (page === to) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <footer className="Footer">
      <div className="Footer-inner">
        <div className="Footer-top">
          <div className="Footer-follow">
            <div className="Footer-label">Follow us on</div>
            <div className="Footer-icons">
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}>
                  <img src={s.icon} alt="" />
                </a>
              ))}
            </div>
          </div>

          <div className="Footer-download">
            <div className="Footer-label">Download our games from</div>
            <div className="Footer-badges">
              <a href={APP_STORE_LINK} target="_blank" rel="noreferrer">
                <img src={APP_STORE_BADGE} alt="Download on the App Store" />
              </a>
              <a href={PLAY_STORE_LINK} target="_blank" rel="noreferrer">
                <img src={PLAY_STORE_BADGE} alt="Get it on Google Play" />
              </a>
            </div>
          </div>
        </div>

        <nav className="Footer-links" aria-label="Footer">
          {legalLinks.map((l) => (
            <Link key={l.to} to={"/" + l.to} onClick={handleLegalClick(l.to)}>{l.text}</Link>
          ))}
          <a href={CAREERS_LINK} target="_blank" rel="noreferrer">Careers</a>
        </nav>

        <div className="Footer-bottom">
          <address className="Footer-company">
            <span>&copy; Metasports Media Private Limited</span>
            {/* placeholder copy: replace with the final brand line / registered address */}
            <span>Hitwicket is a strategy-first cricket game.</span>
          </address>
          <Link to="/" className="Footer-logo" aria-label="Hitwicket home">
            <img src={LOGO} alt="Hitwicket" />
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
